module.exports = __webpack_public_path__ + "img/dimensie-dagelijks_functioneren.350af45a.svg";